module.exports = __webpack_public_path__ + "img/living_2.98509a27.jpg";